module.exports = __webpack_public_path__ + "img/clientesActualizadosResponsive2.82643394.png";